import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { MaskService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

let UiCRechargeComponent = class UiCRechargeComponent {
    constructor(maskService) {
        this.maskService = maskService;
        this.onChange = new EventEmitter();
        this.checkForm = new EventEmitter();
    }
    ngOnInit() { }
    onChangeForm() {
        let valueField = this.maskService.formatValueMoney(this.f('valueField').value);
        this.f('valueField').patchValue(valueField);
        this.onChange.emit(this.formValue);
    }
    f(control) {
        return this.formValue.get(control);
    }
    checkInput(data) {
        let val = this.f('valueField').value.replace(/^0+/, '');
        this.f('valueField').patchValue(val);
        this.checkForm.emit(data);
    }
};
UiCRechargeComponent.ctorParameters = () => [
    { type: MaskService }
];
__decorate([
    Input()
], UiCRechargeComponent.prototype, "primaryMessage", void 0);
__decorate([
    Input()
], UiCRechargeComponent.prototype, "secondaryMessage", void 0);
__decorate([
    Input()
], UiCRechargeComponent.prototype, "formValue", void 0);
__decorate([
    Input()
], UiCRechargeComponent.prototype, "tooltipMessage", void 0);
__decorate([
    Input()
], UiCRechargeComponent.prototype, "errorMessages", void 0);
__decorate([
    Output()
], UiCRechargeComponent.prototype, "onChange", void 0);
__decorate([
    Output()
], UiCRechargeComponent.prototype, "checkForm", void 0);
UiCRechargeComponent = __decorate([
    Component({
        selector: 'ui-c-recharge',
        template: "<div class=\"ui-c-recharge d-flex flex-column align-items-center justify-content-around\">\n  <div class=\" ion-text-center\" *ngIf=\"secondaryMessage !== null\">\n    {{secondaryMessage}}\n  </div>\n  <div class=\"ion-text-start\">\n    {{primaryMessage}}\n  </div>\n  <form class=\"d-flex flex-column justify-content-center align-items-center \" [formGroup]=\"formValue\"\n    (change)=\"onChangeForm()\">\n    <ion-item class=\"d-flex flex-row justify-content-center text-center\">\n      <span class=\"icn-holder\" class=\"align-self-start\">\n        R$\n      </span>\n      <ion-input (change)=\"$event.target.value = $event.target.value.toUpperCase()\"\n        type=\"tel\"\n        class=\"ion-input\"\n        formControlName=\"valueField\"\n        maxlength=\"10\"\n        (ionChange)=\"checkInput($event)\"\n        [brmasker]=\"{money: true, thousand: '.',  decimalCaracter: ',', decimal: '2'}\" [tooltip]=\"tooltipMessage\"\n        prefix=\"R$\"\n        placeholder=\"0,00\">\n      </ion-input>\n    </ion-item>\n    <div class=\"error-messages mt-3\">\n      <ng-container *ngFor=\"let error of errorMessages.valueField\">\n        <div class=\"error-message\"\n          *ngIf=\"formValue.get('valueField').hasError(error.type) && (formValue.get('valueField').dirty || formValue.get('valueField').touched)\">\n          {{error.message | wlpTranslate: error?.param}}\n        </div>\n      </ng-container>\n    </div>\n  </form>\n</div>\n",
        styles: [""]
    })
], UiCRechargeComponent);

let UiCRechargeModule = class UiCRechargeModule {
};
UiCRechargeModule = __decorate([
    NgModule({
        declarations: [UiCRechargeComponent],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            UiBsTranslateModule,
            UiBsUtilModule
        ],
        exports: [
            UiCRechargeComponent
        ]
    })
], UiCRechargeModule);

/*
 * Public API Surface of ui-c-recharge
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCRechargeComponent, UiCRechargeModule };
//# sourceMappingURL=wlp-ui-c-recharge.js.map
